import React from 'react';

const DashboardView = ({ openModal, navigateTo }) => {
    return (
        <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-sm border border-[#F2DFDB]">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 sm:mb-8 text-center sm:text-left">Painel de Controle</h2>
            
            {/* - ALTERAÇÃO: O grid agora começa com 2 colunas no telemóvel (grid-cols-2)
              - e passa para 3 colunas em ecrãs de tamanho médio e maiores (md:grid-cols-3).
              - O espaçamento (gap) também é menor em ecrãs pequenos.
            */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6">

                {/* - ALTERAÇÃO: A classe 'dashboard-button-responsive' será usada
                  - para controlar o tamanho dos botões em diferentes ecrãs.
                  - Os ícones e textos também têm tamanhos responsivos.
                */}

                {/* Botão Vender */}
                <button onClick={() => openModal('registerSale')} className="dashboard-button-responsive">
                    <span className="text-3xl sm:text-4xl">💰</span>
                    <span className="dashboard-button-text">Vender</span>
                </button>

                {/* Botão Buscar Produto */}
                <button onClick={() => navigateTo('registros')} className="dashboard-button-responsive">
                    <span className="text-3xl sm:text-4xl">🔍</span>
                    <span className="dashboard-button-text">Buscar Produto</span>
                </button>

                {/* Botão Cadastrar Produto */}
                <button onClick={() => openModal('addProduct')} className="dashboard-button-responsive">
                    <span className="text-3xl sm:text-4xl">📦</span>
                    <span className="dashboard-button-text">Cadastrar</span>
                </button>

                {/* Botão Clientes */}
                <button onClick={() => navigateTo('customers', 'gestao-clientes')} className="dashboard-button-responsive">
                    <span className="text-3xl sm:text-4xl">👥</span>
                    <span className="dashboard-button-text">Clientes</span>
                </button>

                {/* Botão Minhas Vendas */}
                <button onClick={() => navigateTo('sales', 'historico-vendas')} className="dashboard-button-responsive">
                    <span className="text-3xl sm:text-4xl">📈</span>
                    <span className="dashboard-button-text">Minhas Vendas</span>
                </button>

                {/* Botão Financeiro */}
                <button onClick={() => navigateTo('financeiro', 'contas-a-receber')} className="dashboard-button-responsive">
                    <span className="text-3xl sm:text-4xl">💸</span>
                    <span className="dashboard-button-text">Financeiro</span>
                </button>
            </div>
        </div>
    );
};

export default DashboardView;
